module.exports = __webpack_public_path__ + "static/media/windsurfing_1366.e292af73.jpg";